import React, { useState } from 'react';
import SectionTextMaybe from '../../../ProfilePage/SectionTextMaybe';
import css from './EditListingServicesPanel.module.css';
import { Button } from '../../../../components';

const SavedServices = ({ services, onEditService, handleDeleteService }) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <div className={css.accordion}>
        <div className={css.summary} onClick={toggleAccordion}>
          <span className={`${css.icon} ${isOpen ? css.open : ''}`}>&#9660;</span>
          <div>Added Services</div>
        </div>
        {isOpen && (
          <div className={css.details}>
            <ul>
              {services.map(
                ({ serviceName, servicePrice, serviceDuration, serviceDescription, id }) => (
                  <li key={id} className={css.detailsRow}>
                    <SectionTextMaybe heading="Service" text={serviceName} />
                    <SectionTextMaybe heading="Price" text={servicePrice} />
                    <SectionTextMaybe
                      heading="Duration"
                      text={`${serviceDuration} Hour${serviceDuration > 1 ? 's' : ''}`}
                    />
                    <SectionTextMaybe heading="Description" text={serviceDescription} />
                    <div>
                      <Button className={css.editServiceButton} onClick={() => onEditService(id)}>
                        Edit
                      </Button>
                      <Button
                        className={css.deleteServiceButton}
                        onClick={() => handleDeleteService(id)}
                      >
                        Delete
                      </Button>
                    </div>
                  </li>
                )
              )}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default SavedServices;
